module.exports = __webpack_public_path__ + "img/Illustration 08@1x.b6b98b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Illustration 08@1x.png
// module id = 110
// module chunks = 1